import { QUESTION_REVIEW_TASK_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { NavigateBackLink, QuestionReviewStatusTag } from '@exam-management/components';
import { Flex, PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';
import { useLocation, matchPath } from 'react-router-dom';

import { useQuestionReviewTaskDetails } from '../../providers';
import { QuestionReviewTaskDetailsPageHeaderFinishTaskButton } from '../question-review-task-details-page-header-finish-task-button';

export default function QuestionReviewTaskDetailsPageHeader() {
  const { taskDetails } = useQuestionReviewTaskDetails();
  const { pathname } = useLocation();

  const backPath = matchPath('/my-task/*', pathname) ? '/' : '/task-management/question-review';

  const taskName = taskDetails.parentTask?.id ? taskDetails.parentTask.name : taskDetails.name;

  return (
    <PageHeader
      title={taskName ?? ''}
      subtitleSection={
        <Flex
          sx={{
            justifyContent: 'space-between',
            flex: 1,
          }}
        >
          <Text
            variant='body2'
            sx={{ color: (theme) => theme.palette.text.secondary }}
          >{`Task ID: ${taskDetails.code}`}</Text>
          <Text variant='body2' sx={{ color: (theme) => theme.palette.text.secondary }}>
            Last Modified: {formatDateTime(taskDetails.updatedAt)}
          </Text>
        </Flex>
      }
      endAdornment={
        <>
          <QuestionReviewStatusTag
            status={taskDetails.currentWorkflowStep.code}
            data-testid={QUESTION_REVIEW_TASK_DATA_TEST_ID.STATUS_TAG}
          />
          <QuestionReviewTaskDetailsPageHeaderFinishTaskButton />
        </>
      }
      linkAdornment={<NavigateBackLink to={backPath} label='Back' />}
    />
  );
}
